import React from 'react';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';

const TalkToExpertCont = styled.div`
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    background-image: linear-gradient(283deg, #00c5c5, #00af3a);
    border-radius: 4px;
    color: ${COLOR.WHITE};
    padding: 20px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    place-items: flex-start;
    margin-top: 16px;
    a {
        font-size: 16px;
        color: ${COLOR.GREEN};
        padding: 10px;
        background-color: ${COLOR.WHITE};
        border-radius: 4px;
        width: 200px;
        text-align: center;
    }
`;

interface TalkToExpertProps {
    title: string,
    buttonDiv?: any
}

const TalkToExpert: React.FC<TalkToExpertProps> = (props: TalkToExpertProps) => {
    return (<TalkToExpertCont>
        <span><b>{props.title}</b></span>
        <a href="tel:18002666468">{props?.buttonDiv ? props?.buttonDiv : <span>Talk to Expert</span>}</a>
    </TalkToExpertCont>)
}

export default TalkToExpert;